// document.addEventListener("DOMContentLoaded", function () {
//     const path = window.location.pathname;

//     if (path.includes("policies/shipping-policy")) {
//       let titleElement = document.querySelector(".shopify-policy__title h1");
//       if (titleElement) {
//         titleElement.textContent = "Shipping and Return Policy";
//       }
//     }
//   });

function hideNinety9ProgressBar() {
    const isMiniCart = document.querySelector('.cart-drawer');
    const isCartPage = document.querySelector('.template-cart');

    if (!isMiniCart && !isCartPage) return;

    const productOptions = document.querySelectorAll('.product-option');
    const miniCartDrawer = document.getElementById('progress-bar-ninety9-drawer');
    const cartPageBlock = document.getElementById('progress-bar-ninety9-block-cart');

    let shouldHide = false;

    productOptions.forEach(option => {
      if (option.textContent.toLowerCase().includes('monthly subscription')) {
        shouldHide = true;
      }
    });

    if (shouldHide) {
      if (miniCartDrawer) miniCartDrawer.style.display = 'none';
      if (cartPageBlock) cartPageBlock.style.display = 'none';
    } else {
      if (miniCartDrawer) miniCartDrawer.style.display = '';
      if (cartPageBlock) cartPageBlock.style.display = '';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Run initially
    hideNinety9ProgressBar();

    // Set up observer for dynamic updates
    const targetNode = document.querySelector('.cart-drawer') || document.querySelector('.template-cart');
    if (!targetNode) return;

    const observer = new MutationObserver(() => {
      hideNinety9ProgressBar();
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true
    });
  });

// document.addEventListener("DOMContentLoaded", function () {
//   const tooltipText = "Your pet's microbiome is the community of tiny organisms, like good bacteria, living in their gut that are essential for health.";

//   function walk(node) {
//     if (node.nodeType === 3) {
//       const regex = /\bmicrobiome\b/gi;
//       if (regex.test(node.nodeValue)) {
//         const span = document.createElement("span");
//         span.innerHTML = node.nodeValue.replace(regex, function(match) {
//           return `<span class="tooltip-word" data-tooltip="${tooltipText}">${match}</span>`;
//         });
//         node.parentNode.replaceChild(span, node);
//       }
//     } else if (
//       node.nodeType === 1 &&
//       node.nodeName !== "SCRIPT" &&
//       node.nodeName !== "STYLE" &&
//       node.nodeName !== "TEXTAREA"
//     ) {
//       Array.from(node.childNodes).forEach(walk);
//     }
//   }

//   walk(document.body);
// });
// document.addEventListener("DOMContentLoaded", function () {
//   const isAppleDevice = /Mac|iPhone|iPod|iPad/.test(navigator.platform);
//   const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

//   if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
//     console.log("✅ Apple Pay is available - Shopify will render it.");
//   } else {
//     console.log("❌ Apple Pay not available - Shopify will show Shop Pay or fallback.");
//   }
// });
// document.addEventListener("DOMContentLoaded", function() {
//   document.querySelectorAll('#ruffruff-table-of-contents small').forEach(span => {
//     span.style.display = 'none';
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.template-product .rich-text.plentum-bg .hero__text p a[href="#"]').forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // prevent jumping to top instantly
      window.scrollTo({
        top: 40,
        behavior: "smooth"
      });
    });
  });
});

// document.addEventListener("DOMContentLoaded", function() {
//   const checkBadge = setInterval(function() {
//     const container = document.querySelector(".wt-product__info .jdgm-prev-badge__text");
//     if (container) {
//       // Prevent adding multiple times
//       if (!container.nextElementSibling || container.nextElementSibling.tagName !== "A") {
//         const link = document.createElement("a");
//         link.href = "#benifits-reviews";
//         link.textContent = " See Reviews";
//         link.style.marginLeft = "6px";
//         container.insertAdjacentElement("afterend", link);
//       }
//       clearInterval(checkBadge); // stop checking once added
//     }
//   }, 500); // check every 0.5s
// });

/* PLENTUM_BLOG_TABLE_RENDER_FIX_20260623_JS: blog/article-only table wrapper. Do not run on product/PDP templates. */
(function () {
  function isArticleTemplate() {
    return !!(document.body && /\btemplate-article/.test(document.body.className || ''));
  }

  function getColumnCount(table) {
    var row = table.tHead && table.tHead.rows && table.tHead.rows[0] ? table.tHead.rows[0] : table.rows && table.rows[0];
    return row && row.cells ? row.cells.length : 0;
  }

  function enhancePlentumArticleTables() {
    if (!isArticleTemplate()) return;
    var tables = document.querySelectorAll('main table, article table, .rte table, .article-template table');
    tables.forEach(function (table) {
      if (!table || table.closest('.plentum-table-scroll')) return;
      var columns = getColumnCount(table);
      var wrapper = document.createElement('div');
      wrapper.className = 'plentum-table-scroll' + (columns >= 4 ? ' plentum-wide-table' : '');
      wrapper.setAttribute('data-plentum-columns', String(columns || 0));
      wrapper.style.setProperty('--plentum-table-min-width', Math.min(Math.max((columns || 4) * 168, 680), 1160) + 'px');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePlentumArticleTables);
  } else {
    enhancePlentumArticleTables();
  }
})();

/* PLENTUM_BLOG_TABLE_RENDER_FIX_20260623_V2_JS: article-only table metadata upgrade. Do not run on product/PDP templates. */
(function () {
  function isArticleTemplate() {
    return !!(document.body && /\btemplate-article/.test(document.body.className || ''));
  }

  function getColumnCount(table) {
    var row = table.tHead && table.tHead.rows && table.tHead.rows[0] ? table.tHead.rows[0] : table.rows && table.rows[0];
    return row && row.cells ? row.cells.length : 0;
  }

  function markDensePlentumTables() {
    if (!isArticleTemplate()) return;
    document.querySelectorAll('.plentum-table-scroll table').forEach(function (table) {
      var columns = getColumnCount(table);
      var wrapper = table.closest('.plentum-table-scroll');
      if (!wrapper) return;
      wrapper.setAttribute('data-plentum-columns', String(columns || 0));
      if (columns >= 4) wrapper.classList.add('plentum-wide-table');
      if (columns >= 5) wrapper.classList.add('plentum-dense-table');
      if (!wrapper.style.getPropertyValue('--plentum-table-min-width')) {
        wrapper.style.setProperty('--plentum-table-min-width', Math.min(Math.max((columns || 4) * 180, 920), 1180) + 'px');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markDensePlentumTables);
  } else {
    markDensePlentumTables();
  }
})();

/* PLENTUM_BLOG_TABLE_RENDER_FIX_20260624_V3_JS: article-only overflow containment and no-th header fallback. Do not run on product/PDP templates. */
(function () {
  function isArticleTemplate() {
    return !!(document.body && /\btemplate-article/.test(document.body.className || ''));
  }

  function markTables() {
    if (!isArticleTemplate()) return;
    document.querySelectorAll('.plentum-table-scroll').forEach(function (wrapper) {
      var table = wrapper.querySelector('table');
      if (!table) return;
      wrapper.classList.toggle('plentum-no-th-table', !table.querySelector('th'));
      var rect = wrapper.getBoundingClientRect();
      var overflowsViewport = rect.left < 0 || rect.right > (window.innerWidth || document.documentElement.clientWidth || 0);
      wrapper.classList.toggle('plentum-contained-table', overflowsViewport);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markTables);
  } else {
    markTables();
  }
  window.addEventListener('resize', markTables);
})();



/* PLENTUM_ARTICLE_MOBILE_TABLE_REPAIR_20260705_JS
   Article-template-only mobile table readability repair.
   Adds header labels for mobile row cards where possible.
   Falls back to explicit scroll affordance when header mapping is unsafe.
*/
(function () {
  var MARKER = 'PLENTUM_ARTICLE_MOBILE_TABLE_REPAIR_20260705';
  var MAX_CARD_COLUMNS = 8;

  function isArticleRoute() {
    var bodyClass = document.body ? String(document.body.className || '') : '';
    return /template-article/i.test(bodyClass) || /^\/blogs\//.test(window.location.pathname || '');
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function visibleText(cell) {
    return cleanText(cell ? cell.textContent : '');
  }

  function tableHeaderRow(table) {
    if (table.tHead && table.tHead.rows && table.tHead.rows[0]) return table.tHead.rows[0];
    if (table.rows && table.rows[0] && table.rows[0].querySelector('th')) return table.rows[0];
    return null;
  }

  function headersFor(table) {
    var row = tableHeaderRow(table);
    if (!row || !row.cells) return [];
    return Array.prototype.slice.call(row.cells).map(visibleText);
  }

  function dataRowsFor(table, headerRow) {
    return Array.prototype.slice.call(table.rows || []).filter(function (row) {
      return row && row !== headerRow && row.cells && row.cells.length;
    });
  }

  function applyCardMode(wrapper, table, headers, headerRow) {
    var rows = dataRowsFor(table, headerRow);
    rows.forEach(function (row) {
      Array.prototype.slice.call(row.cells || []).forEach(function (cell, index) {
        cell.setAttribute('data-plentum-mobile-label', headers[index] || '');
      });
    });
    if (headerRow) headerRow.setAttribute('data-plentum-mobile-header-row', 'true');
    wrapper.setAttribute('data-plentum-mobile-mode', 'cards');
    wrapper.setAttribute('data-plentum-mobile-repair', MARKER);
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Readable mobile comparison table');
  }

  function applyScrollMode(wrapper) {
    wrapper.setAttribute('data-plentum-mobile-mode', 'scroll');
    wrapper.setAttribute('data-plentum-mobile-repair', MARKER);
    wrapper.setAttribute('data-plentum-scroll-cue', 'Swipe table to see all columns');
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', 'Scrollable comparison table');
    if (!wrapper.hasAttribute('tabindex')) wrapper.setAttribute('tabindex', '0');
  }

  function enhanceTable(wrapper) {
    if (!wrapper || wrapper.getAttribute('data-plentum-mobile-repair') === MARKER) return;
    var table = wrapper.querySelector('table');
    if (!table) return;
    var headerRow = tableHeaderRow(table);
    var headers = headersFor(table);
    var maxColumns = Math.max.apply(null, Array.prototype.slice.call(table.rows || []).map(function (row) {
      return row && row.cells ? row.cells.length : 0;
    }).concat([0]));
    var labelsSafe = headers.length >= 2 && maxColumns >= 2 && maxColumns <= MAX_CARD_COLUMNS && headers.some(Boolean);
    if (labelsSafe) {
      applyCardMode(wrapper, table, headers, headerRow);
    } else {
      applyScrollMode(wrapper);
    }
  }

  function enhance() {
    if (!isArticleRoute()) return;
    Array.prototype.slice.call(document.querySelectorAll('.plentum-table-scroll')).forEach(enhanceTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
})();
/* /PLENTUM_ARTICLE_MOBILE_TABLE_REPAIR_20260705_JS */
